class TMv_ApplyProgramFilter extends TCv_Form
{
	program_urls;

	constructor(element, options)
	{
		super(element, options);

		this.form_row = document.querySelector('#domestic_form');

		this.program_urls = options.program_application_urls;

		this.addFieldEventListener('program_id','change',this.programFieldChanged.bind(this), true);

	}

	programFieldChanged(event) {

		let program_id = this.fieldValue('program_id');

		if(program_id == '')
		{
			this.form_row.hide();
		}
		else
		{
			if(	this.program_urls[program_id] !== null)
			{
				// change the source
				this.form_row.querySelector('.TMv_PopuliApplicationForm').setAttribute('src',this.program_urls[program_id]);

				// show the form
				this.form_row.slideDown();
			}


		}


	}
}